import { render, staticRenderFns } from "./NoCaptcha.vue?vue&type=template&id=2bffec8e"
import script from "./NoCaptcha.vue?vue&type=script&lang=js"
export * from "./NoCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports